import React from "react";

const MembersTable = ({ members, totalMembers }) => {
  const columns = [
    { id: "rcNumber", label: "RC/Appliction Number" },
    { id: "memberName", label: "Member Name" },
    { id: "aadhaarNumber", label: "Aadhaar", mask: true },
    { id: "dataTime", label: "Appliction Date" },
    { id: "fpsId", label: "FPS ID" },
    { id: "ekycState", label: "Member State" },
    { id: "ekycDistrict", label: "Member District" },
    { id: "mobileNo", label: "Mobile Number" },
    { id: "memberAge", label: "Member Age" },
    { id: "ekycStatus", label: "eKYC Status" },
    { id: "ekycApplicationDateTime", label: "eKYC Date Time" },
    { id: "ekycGender", label: "Member Gender" },
    { id: "ekycDob", label: "Member DOB" },
    { id: "ekycAddress", label: "Member Address" },
  ];

  const schemesValue =
    members && members.length > 0 ? members[0].schemes : null;

  return (
    <div className="mt-4">
      {schemesValue && (
        <div className="flex justify-end -mt-12">
          <div className="bg-gray-100 border border-gray-300 lg:px-4 lg:py-2 px-3 py-2 rounded-md shadow-sm text-sm max-sm:text-xs font-medium text-gray-800">
            Scheme: {schemesValue}
          </div>
        </div>
      )}
      <div className="overflow-x-auto mt-4 border border-gray-200 rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr className="tableheader">
              {columns.map((col) => (
                <th
                  key={col.id}
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-bold text-white uppercase tracking-wider sticky top-0 "
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {members && members.length > 0 ? (
              members.map((member, index) => (
                <tr
                  key={index}
                  className={`${
                    member.searchedMember && totalMembers > 1
                      ? "bg-[#C7DBF0]"
                      : ""
                  } hover:bg-gray-50`}
                >
                  {columns.map((col) => {
                    const value = member[col.id];
                    if (col.id === "ekycStatus") {
                      const isCompleted = value === "Done";
                      return (
                        <td
                          key={col.id}
                          className="px-6 py-4 whitespace-nowrap"
                        >
                          <span
                            className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold leading-5 ${
                              isCompleted
                                ? "text-green-700"
                                : "text-red-700"
                            }`}
                          >
                            {value || "N/A"}
                          </span>
                        </td>
                      );
                    }
                    let displayValue = value;
                    if (col.mask && displayValue) {
                      displayValue = `********${String(displayValue).slice(
                        -4
                      )}`;
                    }
                    return (
                      <td
                        key={col.id}
                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-700"
                      >
                        {displayValue || "N/A"}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="px-6 py-4 text-center text-red-500 font-semibold"
                >
                  Data Not Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MembersTable;
